<template>
  <component
    :is="tag"
    :class="classes"
  >
    <slot />
  </component>
</template>
<script>
export default {
  name: 'DsHeading',
  props: {
    tag: {
      type: String,
      default: 'div',
    },
    size: {
      type: [String, Number],
      default: 500,
      validator(value) {
        const intValue = parseInt(value, 10);
        return [300, 500, 700].includes(intValue);
      },
    },
    align: {
      type: String,
      default: 'left',
      validator(value) {
        return ['left', 'right', 'center'].includes(value);
      },
    },
  },
  computed: {
    classes() {
      return {
        'ds-heading': true,
        [`size-${this.size}`]: true,
        [`align-${this.align}`]: true,
      };
    },
  },
};
</script>
<style lang="stylus" scoped>
@import "../../assets/stylus/variables.styl";

.ds-heading {
  color: $nx-neutral-900;
  font-style: normal;

  &.size-700 {
    font-size: 20px;
    font-weight: 600;
    line-height: 130%; /* 26px */
  }

  &.size-500 {
    font-size: 17px;
    font-weight: 600;
    line-height: 130%; /* 22.1px */
  }

  &.size-300 {
    font-size: 15px;
    font-weight: 600;
    line-height: 130%; /* 19.5px */
  }

  &.align-right {
    text-align: right;
  }

  &.align-center {
    text-align: center;
  }
}
</style>
